import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {apiClient} from '../../../shared/api';

import {
    GET_DOCUMENT_TRAIL_REPORT,
    GET_INVOICE_REPORT,
    GET_MASTER_VIEW_REPORT,
    GET_STATISTIC_REPORT,
    GET_USER_AUDIT_TRAIL_REPORT,
    GET_USER_MANAGEMENT_REPORT,

    GET_MASS_UPDATE_LOG
} from './constants';

import {
    getDocumentAuditTrailFailed,
    getDocumentAuditTrailSuccess,
    getInvoiceReportFailed,
    getInvoiceReportSuccess,
    getMasterViewReportFailed,
    getMasterViewReportSuccess,
    getStatisticReportFailed,
    getStatisticReportSuccess,
    getUserAuditTrailFailed,
    getUserAuditTrailSuccess,
    getUserManagementFailed,
    getUserManagementSuccess,

    getMassUpdateLogFailed,
    getMassUpdateLogSuccess,
} from './actions';

const REPORT_SERVICE = 'report-service/api/v2/report'

const OffsetLimit = (page, sizePerPage) => {
    if (page == 0) {
        return `offset=0&limit=${sizePerPage}`
    } else {
        return `offset=${(page - 1) * sizePerPage}&limit=${sizePerPage}`
    }
}

function* getStatisticReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getStatisticReportSuccess({detail: [], summary: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/statistics?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getStatisticReportFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getStatisticReportSuccess({...response.data, total}));
    }
}

function* getInvoiceReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getInvoiceReportSuccess({data: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/invoices?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getInvoiceReportFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getInvoiceReportSuccess({data: response.data, total}));
    }
}

function* getUserManagementReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getUserManagementSuccess({data: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/user-management?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getUserManagementFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getUserManagementSuccess({data: response.data, total}));
    }
}

function* getUserAuditTrailReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getUserAuditTrailSuccess({data: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/user-audit-trails?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getUserAuditTrailFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getUserAuditTrailSuccess({data: response.data, total}));
    }
}

function* getDocumentAuditTrailReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getDocumentAuditTrailSuccess({data: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/document-history?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getDocumentAuditTrailFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getDocumentAuditTrailSuccess({data: response.data, total}));
    }
}

function* getMasterViewReport({payload: {page, sizePerPage, filter}}) {
    if (!filter) { // In case user change sizePerPage before setting filter
        yield put(getMasterViewReportSuccess({data: [], total: 0}));
        return
    }
    const response = yield call(apiClient.post, `${REPORT_SERVICE}/master-view?${OffsetLimit(page, sizePerPage)}`, filter);

    if (response.error) {
        yield put(getMasterViewReportFailed(response.detail));
    } else {
        const total = parseInt(response.headers['x-total-items']);
        yield put(getMasterViewReportSuccess({data: response.data, total}));
    }
}

// Mass Update Log
const MassUpdateURL = 'report-service/api/v2/mass-update/list'
function* getMassUpdateLog({payload: {filter}}) {
    const response = yield call(apiClient.post, MassUpdateURL, filter);

    if (response.error) {
        yield put(getMassUpdateLogFailed(response.detail));
    } else {
        yield put(getMassUpdateLogSuccess(response.data));
    }
}

export function* watchGetStatisticReport(): any {
    yield takeEvery(GET_STATISTIC_REPORT, getStatisticReport);
    yield takeEvery(GET_INVOICE_REPORT, getInvoiceReport);
    yield takeEvery(GET_USER_MANAGEMENT_REPORT, getUserManagementReport);
    yield takeEvery(GET_USER_AUDIT_TRAIL_REPORT, getUserAuditTrailReport);
    yield takeEvery(GET_DOCUMENT_TRAIL_REPORT, getDocumentAuditTrailReport);
    yield takeEvery(GET_MASTER_VIEW_REPORT, getMasterViewReport);
    yield takeEvery(GET_MASS_UPDATE_LOG, getMassUpdateLog);
}

function* reportCoreSaga(): any {
    yield all([
        fork(watchGetStatisticReport),
    ]);
}

export default reportCoreSaga;